import { FilterMatchMode } from "primereact/api";
import { Tag } from "primereact/tag";

export class ClientePn {
    constructor({ formularioMatriz } = {}) {
        this.formularioMatriz = formularioMatriz;

        this.model = {
            id: {
                export: true,
                header: 'Código',
                table: true,
                filter: true,
                filterPlaceholder: 'ID',
                filterField: 'id',
                sort: true,
                isNumeric: true,
                matchMode: FilterMatchMode.EQUALS,
                showFilterMatchModes: false,
                headerStyle: { width: '10rem', minWidth: '10rem', textAlign: 'left' },
                bodyStyle: { textAlign: 'left' },
                body: (rowData) => (
                    <span className="font-semibold text-blue-700 bg-blue-50 px-2 py-1 border-round text-sm">
                        #{rowData.id}
                    </span>
                )
            },
            fecha: {
                value: new Date(),
                export: true,
                header: 'Fecha',
                required: 'Fecha es requerido',
                table: true,
                sort: true,
                filter: true,
                isDate: true,
                headerStyle: { width: '10rem', minWidth: '10rem' },
                body: (rowData) => {
                    if (!rowData.fecha) return null;
                    const fechaFormateada = new Date(rowData.fecha + 'T00:00:00').toLocaleDateString();
                    return (
                        <div className="flex align-items-center text-700 text-sm">
                            <i className="pi pi-calendar mr-2 text-primary-400"></i>
                            <span>{fechaFormateada}</span>
                        </div>
                    );
                }
            },
            nombre_completo: {
                export: true,
                header: 'Nombre Completo',
                table: true,
                sort: false,
                filter: true,
                headerStyle: { width: '25%', minWidth: '18rem' },
                filterPlaceholder: 'Buscar por nombres...',
                filterField: 'nombre_completo',
                matchMode: FilterMatchMode.CONTAINS,
                body: (rowData) => (
                    <div className="flex flex-column">
                        <span className="font-bold text-900 text-sm uppercase">{rowData.nombre_completo}</span>
                    </div>
                )
            },
            identificacion: {
                export: true,
                header: 'Identificación',
                filterPlaceholder: 'No. documento',
                filterField: 'identificacion',
                matchMode: FilterMatchMode.CONTAINS,
                table: true,
                filter: true,
                sort: true,
                headerStyle: { width: '11rem', minWidth: '11rem' },
                body: (rowData) => (
                    <div className="flex align-items-center text-700 text-sm">
                        <i className="pi pi-id-card mr-2 text-500"></i>
                        <span className="font-mono">{rowData.identificacion}</span>
                    </div>
                )
            },

            razon_social: {
                export: true,
                header: 'Empresa',
                table: true,
                sort: true,
                filter: true,
                filterPlaceholder: 'Buscar empresa...',
                filterField: 'razon_social',
                matchMode: FilterMatchMode.CONTAINS,
                headerStyle: { width: '20%', minWidth: '15rem' },
                body: (rowData) => (
                    <div className="flex align-items-center text-800">
                        <i className="pi pi-building mr-2 text-500 text-sm"></i>
                        <span className="font-medium text-sm">{rowData.razon_social}</span>
                    </div>
                )
            },
            estado_formulario: {
                value: null,
                export: true,
                header: 'Estado',
                table: true,
                headerStyle: { width: '11rem', minWidth: '11rem', textAlign: 'left' },
                bodyStyle: { textAlign: 'left' },
                filter: true,
                filterPlaceholder: 'Estado',
                matchMode: FilterMatchMode.CONTAINS,
                body: (rowData) => {
                    const estado = rowData.estado_formulario;
                    const nemonico = rowData.nemonico;
                    let severity = 'info';
                    let icon = 'pi pi-info-circle';

                    switch (nemonico) {
                        case 'BORRADOR':
                            severity = 'warning';
                            icon = 'pi pi-file-edit';
                            break;
                        case 'ENVIADO':
                            severity = 'info';
                            icon = 'pi pi-send';
                            break;
                        case 'FINALIZADO':
                            severity = 'success';
                            icon = 'pi pi-check-circle';
                            break;
                        case 'CANCELADO':
                            severity = 'danger';
                            icon = 'pi pi-times-circle';
                            break;
                        default:
                            severity = 'secondary';
                            break;
                    }

                    return (
                        <div className="flex align-items-center">
                            <Tag value={estado} severity={severity} icon={`${icon} mr-1`} className="text-xs px-2 py-1 font-semibold" rounded />
                        </div>
                    );
                }
            },
            matriz: {
                value: null,
                export: true,
                header: 'Matriz:',
                table: formularioMatriz,
                headerStyle: { width: '10%', minWidth: '11rem' },
                filter: false,
                body: (rowData) => rowData.matriz ? (
                    <Tag value={rowData.matriz} severity="secondary" className="text-xs" />
                ) : <span className="text-400 text-xs italic">N/A</span>
            },
        };
    }

    optionLabel = 'nombre';
    titulo = "Instrucciones de envío";

    pasosInstrucciones = [
        {
            titulo: "Paso 1",
            texto: <>Complete la información requerida en cada una de las secciones del formulario. Para guardar los avances y avanzar entre secciones, haga clic en el botón <b>"Siguiente"</b>. En la última sección del formulario, haga clic en el botón <b>"Guardar"</b> para consolidar la información registrada.</>
        },
        {
            titulo: "Paso 2",
            texto: <>Una vez guardada la información, haga clic en el botón <b>"Formulario"</b> para generar y descargar el documento en formato PDF, el cual debe ser impreso y firmado.</>
        },
        {
            titulo: "Paso 3",
            texto: <>El botón de <b>"Anexos"</b> se ubica en la última sección del formulario. Desde allí, adjunte el formulario principal firmado y todos los documentos de soporte requeridos.</>
        },
        {
            titulo: "Paso 4",
            texto: <>Una vez verificado que la información del formulario esté completa y que todos los anexos hayan sido cargados correctamente, haga clic en el botón <b>"Enviar"</b> para completar de manera exitosa el proceso.</>
        },
        {
            titulo: "Nota",
            texto: <>Los datos ingresados en el formulario pueden ser modificados en cualquier momento, siempre y cuando la información no haya sido <b>enviada</b> en el sistema.</>,
            isNote: true
        }
    ];
}
